import styled from 'styled-components'

const IconSpanContainer = styled.span`
  padding-left: 0.6rem;
  padding-right: 0.6rem;
`
export default IconSpanContainer;
